import React from 'react'
import { useScrollAnimation } from '../hooks/useScrollAnimation'

const CTA = () => {
  const { ref, isVisible } = useScrollAnimation()

  return (
    <section id="cta" className="cta section section-dark" ref={ref}>
      <div className="container">
        <div className={`cta-card ${isVisible ? 'animate-fadeInUp' : ''}`}>
          <div className="section-header">
            <div className={`section-tag ${isVisible ? 'animate-fadeInUp' : ''}`}>Get Started Today</div>
            <h2>Ready to Take the Next Step?</h2>
            <p className="section-subtext">
              Whether you're seeking top talent or your dream role, we're here to make it happen.
            </p>
          </div>
          
          <div className="cta-buttons">
            <button 
              className="btn btn-gold btn-large"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Contact Us Today
            </button>
            <button 
              className="btn btn-outline-white btn-large"
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Our Services
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CTA
